import React from 'react';
import Lottie from 'react-lottie';
import './Support_lottie.css';
import * as animationData from './Support_lottie.json';

function Support_lottie() {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  return (
    <section className='main'>
      <div className='Support_lottie_icon'>
        <Lottie className="me-auto"
          options={defaultOptions}
        // height={60}
        // width={60}          
        />
      </div>
    </section>
  );
}
export default Support_lottie;